<template>
  <div class="d-flex flex-row align-items-end gap-3">
    <template v-if="!status">
      Error: Could not find status with ID "{{ statusId }}"
    </template>
    <template v-else>
      <div class="w-100">
        <label v-if="showLabels" class="form-label">Label</label>
        <input type="text" class="form-control" v-model="statusLabel" />
      </div>
      <div class="w-50">
        <label v-if="showLabels" class="form-label">Code</label>
        <input type="text" class="form-control" v-model="statusCode" />
      </div>
      <div class="w-25">
        <label v-if="showLabels" class="form-label">Type</label>
        <select class="form-select" v-model="statusType">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="pending">Pending</option>
        </select>
      </div>
      <button type="button" class="btn btn-icon btn-flat flex-shrink-0" @click="$emit('remove', status.id)">
        <i class="bi-trash"/>
      </button>
    </template>
  </div>
</template>

<script>
import {LicenseWorkflow} from "@/models/LicenseWorkflow";

export default {
  emits: ['remove'],
  props: {
    showLabels: Boolean,
    workflow: LicenseWorkflow,
    statusId: String
  },
  computed: {
    /**
     * {id, code, label, type}
     */
    status() {
      return this.workflow.getStatus(this.statusId);
    },
    statusLabel: {
      get() {
        return this.status?.label;
      },
      set(label) {
        this.status.label = label;
      }
    },
    statusCode: {
      get() {
        return this.status?.code;
      },
      set(code) {
        this.status.code = code;
      }
    },
    statusType: {
      get() {
        return this.status?.type;
      },
      set(type) {
        this.status.type = type;
      }
    }
  }
}
</script>
